import { render, staticRenderFns } from "./giveUp.vue?vue&type=template&id=51b32051&scoped=true&"
import script from "./giveUp.vue?vue&type=script&lang=js&"
export * from "./giveUp.vue?vue&type=script&lang=js&"
import style0 from "./giveUp.vue?vue&type=style&index=0&id=51b32051&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b32051",
  null
  
)

export default component.exports